import { TIPO_EMPRESA_USUARIO } from "api/Types/TipoEmpresa"
import { TFunction } from "i18next"

export const setTitleModalCrearEmpresa = (
  mode: number,
  t: TFunction
): string => {
  switch (mode) {
    case TIPO_EMPRESA_USUARIO.EMPRESA:
      return `${t("seleccionDeEmpresa.modal.dataEmpresa")}`
    case TIPO_EMPRESA_USUARIO.AUTONOMO:
      return `${t("seleccionDeEmpresa.modal.dataPersonal")}`
    case TIPO_EMPRESA_USUARIO.ASESORIA:
      return `${t("seleccionDeEmpresa.modal.dataAsesoria")}`
    default:
      return `${t("seleccionDeEmpresa.modal.dataEmpresa")}`
  }
}
